import { Provider } from 'react-redux';
import type { Store } from 'redux';
import globalStore from '../../config/redux/store';
import Routes from './Routes';
import WithGoogleAnalytics from '../../features/tracking/components/WithGoogleAnalytics';
import WithConsentManager from '../../features/consentManager/components/WithConsentManager';
import WithTracking from '../../features/tracking/components/WithTracking';

interface ConnectedRoutesProps {
  store?: Store;
}

const defaultProps: Pick<ConnectedRoutesProps, 'store'> = {
  store: globalStore,
};

export default function ConnectedRoutes({ store }: ConnectedRoutesProps): JSX.Element | null {
  return (
    <WithConsentManager>
      <WithGoogleAnalytics>
        <WithTracking>
          <Provider store={store || globalStore}>
            <Routes />
          </Provider>
        </WithTracking>
      </WithGoogleAnalytics>
    </WithConsentManager>
  );
}

ConnectedRoutes.defaultProps = defaultProps;
